import { useState, useEffect } from 'react';
import { ReadingsService } from 'src/services/readings/readings.service';

type UseGetLatestGatewayReadingsArgs = {
  gatewayId?: string;
  tagId?: string | string[];
};

export const useGetLatestGatewayReadings = ({
  gatewayId,
  tagId,
}: UseGetLatestGatewayReadingsArgs) => {
  const [readings, setReadings] = useState<any>({});
  const [isDataReady, setIsDataReady] = useState<boolean>(false);

  useEffect(() => {
    if (!gatewayId || !tagId) return;

    ReadingsService.getLatestReadingsNewDataStorage({
      gatewayId: gatewayId,
      measurements: tagId,
    })
      .then((res) => {
        if (res !== null) {
          setReadings(res.data);
        }
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        setIsDataReady(true);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tagId, gatewayId]);

  return { readings, isDataReady };
};
